<template>
  <div class="container-simple-table">
    <div class="header-table">
      <div class="search-container">
        <search width="70%" height="35px" @searchtext="searchtext($event)" />
      </div>
    </div>
    <b-table
      v-if="data.length > 0"
      :data="isEmpty ? [] : data"
      :selected.sync="selected"
      :paginated="true"
      pagination-size="is-small"
      :loading="isLoading"
      focusable
      striped
      @contextmenu="showContext"
    >
      <b-table-column field="acoes" label="Ações" header-class="custom-header" centered>
        <b-dropdown aria-role="list" title="Ações">
          <h1 slot="trigger" class="row-actions-circles">
            <div class="circle" />
            <div class="circle" />
            <div class="circle" />
          </h1>

          <b-dropdown-item aria-role="listitem">
            <div class="menu-row-option" @click="$emit('editAction', selected)">
              <feather class="menu-row-icon archive" type="edit" size="16" />
              <h1>Editar</h1>
            </div>
          </b-dropdown-item>
        </b-dropdown>
      </b-table-column>
      <b-table-column
        v-slot="props"
        field="id"
        label="ID"
        width="40"
        header-class="custom-header"
        numeric
      >
        <h1 :ref="'a' + props.row.id" class="table-title-cad">
          {{ props.row.id }}
        </h1>
      </b-table-column>

      <b-table-column
        v-slot="props"
        field="descricao"
        header-class="custom-header"
        label="Descrição"
      >
        <h1 class="table-title-cad">
          {{ props.row.descricao }}
        </h1>
      </b-table-column>

      <b-table-column v-slot="props" field="status" label="Status" header-class="custom-header">
        <h1 class="table-title-cad tag-status">
          <tag :state="props.row.status" :data="props.row.status == 0 ? 'Inativo' : 'Ativo'" />
        </h1>
      </b-table-column>

      <b-table-column
        v-slot="props"
        field="associado_id"
        label="Associado ID"
        centered
        header-class="custom-header"
      >
        <span class="table-title-cad">
          {{ props.row.associado_id }}
        </span>
      </b-table-column>

      <b-table-column v-slot="props" label="Integração ID" header-class="custom-header">
        <span class="table-title-cad">
          {{ props.row.integracao_id }}
        </span>
      </b-table-column>
      <vue-context ref="menu">
        <div class="menu-row">
          <div class="menu-row-box">
            <div class="menu-row-option">
              <feather class="menu-row-icon check" type="alert-circle" size="16" />
              <h1>Informações</h1>
            </div>
          </div>

          <div class="menu-row-box-bottom">
            <div class="menu-row-option" @click="$emit('editAction', selected)">
              <feather class="menu-row-icon archive" type="edit" size="16" />

              <h1>Editar</h1>
            </div>

            <div class="menu-row-option">
              <feather class="menu-row-icon check" type="copy" size="16" />

              <h1>Copiar</h1>
            </div>

            <div class="menu-row-option">
              <feather class="menu-row-icon danger" type="trash-2" size="16" />

              <h1>Deletar</h1>
            </div>
          </div>
        </div>
      </vue-context>
    </b-table>
    <Empty
      v-if="data.length <= 0 && isLoading === false"
      message="Nenhum item encontrado"
      subtitle="Tente alterar os filtros"
    />
  </div>
</template>

<script>
import VueContext from 'vue-context';
import search from '../search/index';
import 'vue-context/src/sass/vue-context.scss';
import tag from '../tags/situation';
import Empty from '../empty';

export default {
	components: {
		search,
		VueContext,
		tag,
		Empty,
	},

	props: {
		data: {
			type: Array,
			default: () => [],
		},
		isLoading: {
			type: Boolean,
			default: true,
		},
		labels: {
			type: Array,
			default: () => [],
		},
	},

	data() {
		return {
			selected: {},
			isEmpty: false,
			isBordered: false,
			isStriped: false,
			isNarrowed: false,
			isHoverable: false,
			isFocusable: false,
			hasMobileCards: true,
		};
	},
	watch: {
		selected(e) {
			this.$nextTick(() => {
				this.focustTable(`a${e.id}`);
			});
		},
	},
	methods: {
		focustTable(refId = 'a139') {
			this.$refs[refId].scrollIntoView({ behavior: 'smooth', block: 'center', inline: 'nearest' });
		},
		searchtext(params) {
			this.$emit('searchtext', params);
		},
		showmodal() {
			this.$emit('editaction', this.selected);
		},

		showContext(row, context) {
			this.selected = row;

			context.preventDefault();

			this.$refs.menu.open(context, row);
		},
	},
};
</script>

<style lang="scss" scoped>
.container-simple-table {
  margin-bottom: 20px;
  background-color: #fff;
  padding: 13px;
  border-radius: 5px;
}
.search-container {
  width: 60%;
}
.header-table {
  width: 100%;
  background-color: #fff;
  justify-content: space-between;
  height: 60px;
  padding: 20px;
}

.table-title-cad {
  display: flex;
  color: $row-color;
  font-weight: $row-weight;
  margin-top: 5px;
  margin-bottom: 2px;
  font-size: $row-size;
}

.custom-header {
  font-size: $header-size;
  font-weight: $header-weight;
  color: $header-color;
}

.is-success {
  display: flex;
  align-items: center;
}

.menu-row-icon {
  color: #8b83ba;
  padding-left: 10px;
  padding-right: 10px;
  font-weight: 500;
}

.menu-row-box-bottom {
  padding-top: 10px;
}

.menu-row-box {
  padding-bottom: 10px;
  border-bottom: 1px solid #f2f0f9;
}

.menu-row-option:first-child {
  margin-top: 5px;
}

.menu-row-option:hover {
  color: #25213b !important;
  border-radius: 5px;
}

.menu-row-option:hover .danger {
  color: #dc3545 !important;
}

.menu-row-option:hover .check {
  color: #007f00;
}

.menu-row-option:hover .archive {
  color: #f77f00;
}

.menu-row-option {
  display: flex;
  align-items: center;
  margin-left: 5px;
  margin-right: 5px;
  padding: 10px;
  cursor: pointer;
}
//Actions
.disabled {
  cursor: not-allowed !important;
}
.dropdown-menu {
  font-size: 12px !important;
}
.circle {
  width: 4px;
  height: 4px;
  margin: 1px;
  border-radius: 50%;
  background-color: rgb(212, 212, 212);
  transition: ease-in-out 0.5s;
}
.row-actions-circles {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 10px;
}
.row-actions-circles:hover {
  cursor: pointer;
}
.row-actions-circles:hover .circle {
  background-color: rgb(139, 139, 139);
}
</style>
